import { Monthly10k } from '@daymade/common-lib/constants';
import { CONFIRMATION_ASSET_FOLDER } from 'constants/Confirmation';
import Link from 'next/link';

export const PERKS = [
  {
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/monthly.svg`,
    header: 'Monthly £10K Giveaway',
    description: (
      <>
        Earn entries into this epic{' '}
        <Link href={Monthly10k.urlPath} className="textLink">
          <a className="textDecorationUnderline">subscribers only raffle</a>
        </Link>{' '}
        every week you're subscribed
      </>
    ),
    test: true,
  },
  {
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/discounts.svg`,
    header: 'Epic Discounts',
    description: (
      <>
        From companies like Virgin <br /> Experience Days. Wild deodorant &{' '}
        <Link href="/my-discounts" className="textLink">
          <a>more</a>
        </Link>
      </>
    ),
  },
  {
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/games.svg`,
    header: 'Exclusive Games',
    description: (
      <>
        Awesome draws and raffles <br /> down in{' '}
        <Link href="/token-town" className="textLink">
          <a className="textDecorationUnderline">Token Town</a>
        </Link>
      </>
    ),
  },
  {
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/give-back.svg`,
    header: 'A tree a week',
    description: (
      <>
        You’ll plant a tree <br /> every week with{' '}
        <Link href="https://www.veritree.com/" className="textLink">
          <a
            className="textDecorationUnderline"
            target="_blank"
            rel="noopener noreferrer"
          >
            veritree
          </a>
        </Link>
      </>
    ),
  },
];

export const filterPerksByTestGroup = (isInMonthlyTestGroup: boolean) => {
  return PERKS.filter((perk) => !perk.test || isInMonthlyTestGroup);
};
